import TableHeader from "./TableHeader/TableHeader"
import TableItem from "./TableItem/TableItem"
import useStyle from "./useStyle"

function Table({ rows }) {
  const classes = useStyle()

  return (
    <div className={classes.root}>
      <div className={classes.tableWrap}>
        <table className={classes.table}>
          <TableHeader />
          <tbody className={classes.tableBody}>
            {rows &&
              rows.map((item, index) => (
                <TableItem
                  listIndex={index}
                  key={item.communicationSubscriptionVEId}
                  item={item}
                />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Table
